import React, { FunctionComponent } from 'react'

const NoMatch: FunctionComponent = (): React.ReactElement => <h1>404 – Seite nicht gefunden</h1>

export default NoMatch
